export default __webpack_public_path__ + "static/media/partner_04.9800c070.png";